'use client';

import { getCookieValue, setCookie } from '@/utils/cookie';
import { newDate } from '@/utils/date';
import { differenceInSeconds } from 'date-fns';
import { notFound } from 'next/navigation';
import { useEffect, useRef } from 'react';

// リファラ制限してる場合の処理コンポーネント
function CheckReferrer({
  approveReferrer,
  lotteryId,
  startAt,
  endAt,
  isPreview = false,
}: {
  approveReferrer?: string;
  lotteryId: number;
  startAt: string;
  endAt?: string;
  isPreview?: boolean;
}) {
  const checkingRef = useRef(false);
  const cookieKey = `approved_referrer_${lotteryId}`;
  useEffect(() => {
    // そもそもリファラ制限をしてない場合
    if (!approveReferrer) return;
    // プレビュー時は無条件で通す
    if (isPreview) return;
    if (checkingRef.current) {
      return;
    }
    checkingRef.current = true;
    if (getCookieValue(cookieKey) === 'true') return;

    const lastSegment = approveReferrer.split('/').pop();

    //TODO: デバッグ用
    if (lastSegment !== undefined) {
      console.log('lastSegment', lastSegment);
      console.log('getCookieValue(lastSegment)', getCookieValue(lastSegment));
    }
    if (lastSegment === undefined || getCookieValue(lastSegment) !== 'true') {
      notFound();
    }
    // リロード対策にクッキーをセット
    // maxAgeはくじ開催期間と同じ
    const hasPeriod = endAt && startAt;
    const maxAge = hasPeriod ? differenceInSeconds(newDate(endAt), newDate(startAt)) : 0;
    setCookie(cookieKey, 'true', maxAge);
  }, []);
  return <></>;
}

export default CheckReferrer;
